const EventBus = {
    events: {},

    on(event, listener) {
        if (!this.events[event]) {
            this.events[event] = [];
        }
        this.events[event].push(listener);
    },

    off(event, listenerToRemove) {
        if (!this.events[event]) return;

        this.events[event] = this.events[event].filter(listener => listener !== listenerToRemove);
    },

    emit(event, data) {
        if (!this.events[event]) return;

        this.events[event].forEach(listener => listener(data));
    },
    // Đăng ký một lần và tự động hủy sau khi được gọi
    once(event, listener) {
        const wrapper = (...args) => {
            listener(...args);
            this.off(event, wrapper); // Tự động xóa listener sau khi gọi
        };
        this.on(event, wrapper);
    }
};

export default EventBus;
